/**
 * ปิดช่องทางชำระเงินด้วยบัตรเครดิต/เดบิตชั่วคราว
 * เปลี่ยนเป็น true เพื่อเปิดใช้งานกลับ
 *
 * เมื่อเป็น false:
 * - ซ่อนช่องทาง "บัตรเครดิต/เดบิต" ในหน้าเลือกช่องทางชำระเงิน
 * - ไม่ตั้งบัตรเครดิตเป็นช่องทางเริ่มต้นให้อัตโนมัติ (ตอนเปิดหน้าและหลังล็อกอิน)
 *
 * หมายเหตุ: หน้าจัดการบัตร (PaymentCreditList/PaymentCredit/PaymentCreditEdit)
 * ยังคงทำงานได้ตามปกติ เพียงแต่ไม่มีทางเข้าจาก UI ในระหว่างที่ปิดช่องทางนี้
 */
export const isCreditCardPaymentEnabled = false;

/**
 * ปิดรับสมัครสมาชิกใหม่
 * เปลี่ยนเป็น true เพื่อเปิดรับสมัครกลับ
 *
 * เมื่อเป็น false:
 * - ซ่อนปุ่ม "สมัครสมาชิก" ใน header (HeaderNav ทั้ง desktop/mobile และ HeaderDesktop)
 * - ซ่อนลิงก์ "สมัครสมาชิก" ใน modal เข้าสู่ระบบ (ModalLogin)
 * - ไม่ mount ModalRegister ใน routes ทำให้ไม่มีทางเปิดฟอร์มสมัครได้
 *
 * หมายเหตุ: หน้า /register-invite (สมัครผ่านคำเชิญ sub-user) ยังทำงานได้ตามปกติ
 */
export const isRegisterEnabled = false;

export default {
	isCreditCardPaymentEnabled,
	isRegisterEnabled,
};
